<div class="container-fluid">
    <div class="row my-2 mb-5">
        <div class="col d-flex justify-content-md-center">
            <h3>Gestione Rifornimenti <small>Parco {{ parkName }}</small></h3>
        </div>
    </div>
    <div *ngIf="!noRefills" class="row mt-5">
        <div class="col">
            <mat-form-field class="plate-search-input">
                <mat-label>Cerca targa</mat-label>
                <input matInput (input)="applyPlateSearchFilter($event.target.value)" placeholder="Eg. CRI001" #input />
            </mat-form-field>
        </div>
    </div>
    <div class="row mb-5">
        <div *ngIf="noRefills" class="col d-flex justify-content-md-center">
            <h3><em>Non ci sono dei rifornimenti effettuati in questo parco</em></h3>
        </div>
        <div *ngIf="!noRefills" class="col">
            <table mat-table matSort [dataSource]="refillsTableDataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="rfl_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID rifornimento</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element?.rfl_id }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="trv_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID viaggio</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element?.trv_id }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="vhc_plate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Targa</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element?.vhc_plate }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button aria-label="Edit item" (click)="onRefillRowActionHandler(element)">
                            <mat-icon>settings</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="refillsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: refillsDisplayedColumns"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[50, 100, 250]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>